import React, { useState } from "react";
import { Link } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import avatar from "../../images/avatar.png";
import LogoutModal from "../../modal/LogoutModal";

function Profile() {
  const [isOpen, setIsOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const toggleOpen = () => setIsOpen(!isOpen);
  const menuClass = `dropdown-menu${isOpen ? " show" : ""}`;
  const { firstName, lastName, role } = useAuth();
  return (
    <React.Fragment>
      {showModal && <LogoutModal modal={showModal} setModal={setShowModal} />}
      <div className="user-profile">
        <img src={avatar} alt="User Avatar" className="avatar" />
        <div className="user-details" onClick={toggleOpen}>
          <h5
            className="name dropdown-toggle fs-15 mb-0"
            type="button"
            id="dropdownMenuButton"
          >
            {firstName} {lastName}
          </h5>
          <p className="designation fs-13 mb-0">{role}</p>
          <div className="dropdown">
            <ul
              className={"dropdown-menu-end border-0 shadow-lg " + menuClass}
              aria-labelledby="dropdownMenuButton"
              data-bs-popper="static"
            >
              <li>
                <Link role="button" className="dropdown-item" to="/my-account">
                  My Account
                </Link>
              </li>
              <li>
                <Link
                  role="button"
                  className="dropdown-item"
                  to="/change-password"
                >
                  Change Password
                </Link>
              </li>
              <li>
                <Link role="button" className="dropdown-item" to="/users">
                  Users
                </Link>
              </li>
              <li>
                <a
                  role="button"
                  className="dropdown-item"
                  onClick={() => setShowModal(true)}
                >
                  Log Out
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
export default Profile;
